var React = require('react');

function Ellipsis (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.6606 3.016C18.6606 4.296 19.6526 5.32 20.9966 5.32C22.2766 5.32 23.2686 4.296 23.2686 3.016C23.2686 1.672 22.2766 0.712 20.9966 0.712C19.6526 0.712 18.6606 1.672 18.6606 3.016ZM0.740625 3.016C0.740625 4.296 1.73263 5.32 3.07663 5.32C4.35663 5.32 5.34863 4.296 5.34863 3.016C5.34863 1.672 4.35663 0.712 3.07663 0.712C1.73263 0.712 0.740625 1.672 0.740625 3.016ZM9.70063 3.016C9.70063 4.296 10.6926 5.32 12.0366 5.32C13.3166 5.32 14.3086 4.296 14.3086 3.016C14.3086 1.672 13.3166 0.712 12.0366 0.712C10.6926 0.712 9.70063 1.672 9.70063 3.016Z","fill":"black"}));
}

Ellipsis.defaultProps = {"width":"24","height":"6","viewBox":"0 0 24 6","fill":"none"};

module.exports = Ellipsis;

Ellipsis.default = Ellipsis;
